// extracted by mini-css-extract-plugin
export default {"brandContainer":"BrandName_brandContainer__rFhbT","collapsedInitial":"BrandName_collapsedInitial__SsRkc"};